import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import axiosInstance from './axiosInstance';

const AuthSessionContext = createContext(null);

export const AuthSessionProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const response = await axiosInstance.get('/api/v1/auth/me');
      const data = response?.data?.data ?? response?.data?.data?.data ?? response?.data?.data ?? null;
      setUser(data || null);
      if (data) {
        console.info('[AUTH] /auth/me user roles:', data.roles || []);
      }
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const logout = useCallback(() => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
    window.location.href = `${baseUrl}/api/v1/auth/logout?next=${encodeURIComponent(window.location.origin)}`;
  }, []);

  const value = useMemo(
    () => ({
      user,
      roles: user?.roles || [],
      loading,
      refresh: fetchMe,
      logout,
    }),
    [user, loading, fetchMe, logout]
  );

  return <AuthSessionContext.Provider value={value}>{children}</AuthSessionContext.Provider>;
};

export const useAuthSession = () => {
  const ctx = useContext(AuthSessionContext);
  if (!ctx) {
    throw new Error('useAuthSession must be used within AuthSessionProvider');
  }
  return ctx;
};
